import React, { useContext, useMemo } from 'react';
import Lottie from 'lottie-react';
import restaurantAnimation from '../../animations/restaurant-animation.json';
import { ThemeContext } from '../../context/ThemeContext';
import { getPrimaryColor } from '../../styles/liquidTheme';
import recolorLottieAnimation from '../../utils/recolorLottieAnimation';

const SIZES = {
  xs: 20,
  small: 32,
  medium: 80,
  large: 200,
};

function resolveSize(size) {
  if (typeof size === 'number') return size;
  return SIZES[size] ?? SIZES.large;
}

const LoadingAnimation = React.memo(({
  size = 'large',
  message,
  fullPage = false,
  inline = false,
  minHeight,
  className,
  style,
}) => {
  const { theme } = useContext(ThemeContext);
  const primaryColor = getPrimaryColor(theme);
  const animationData = useMemo(
    () => recolorLottieAnimation(restaurantAnimation, primaryColor),
    [primaryColor],
  );
  const dimension = resolveSize(size);

  const lottie = (
    <Lottie
      animationData={animationData}
      loop
      autoplay
      style={{ width: dimension, height: dimension, flexShrink: 0 }}
    />
  );

  if (inline) {
    return (
      <span
        className={className}
        style={{ display: 'inline-flex', verticalAlign: 'middle', alignItems: 'center', ...style }}
      >
        {lottie}
      </span>
    );
  }

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: message ? '1rem' : 0,
        textAlign: 'center',
        ...(fullPage ? { minHeight: '100vh', width: '100%' } : {}),
        ...(minHeight ? { minHeight } : {}),
        ...style,
      }}
    >
      {lottie}
      {message ? (
        <p
          style={{
            margin: 0,
            fontSize: fullPage ? '1.5rem' : '1.25rem',
            fontWeight: 600,
            lineHeight: 1.4,
          }}
        >
          {message}
        </p>
      ) : null}
    </div>
  );
});

LoadingAnimation.displayName = 'LoadingAnimation';

export default LoadingAnimation;
